export default __webpack_public_path__ + "static/media/Ayeola.5f249180.jpg";